import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom';
import { 
    CbSection_1,
    CbGoldStandard,
    CbQuickToMarket,
    CbHowDoWeDoIt,
    CbCoCreate,
    CbNluOrLanguageModels
} from './component'
const CustomBuilt = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                const elementTop = element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: elementTop - 100,
                    behavior: 'smooth'
                });
            }
        }
        else{
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [location]);
    return (
        <>
            <section className="hero-area hero-area-background">
                <CbSection_1/>
            </section>
            <section className='mt-20'>
                <div className="container">
                    <div id="how-do-we-do-it" className=''>
                        <CbHowDoWeDoIt />
                    </div>
                    <div id="gold-standard">
                        <CbGoldStandard />
                    </div>
                    <div id="nlu-language-models">
                        <CbNluOrLanguageModels/>
                    </div>
                    <div id="quick-to-Market">
                        <CbQuickToMarket />
                    </div>
                    <div id="co-create">
                        <CbCoCreate/>
                    </div>
                </div>
            </section>
        </>
    )
}

export {CustomBuilt}